import { useEffect, useRef } from "react";

/**
 * Autofocus a field without letting the browser scroll it into view. Plain `autoFocus` focuses
 * with the default scroll-into-view, which on iOS drags the document behind a bottom sheet as the
 * keyboard opens. Focuses once on mount.
 */
export function useAutoFocusNoScroll<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  useEffect(() => {
    ref.current?.focus({ preventScroll: true });
  }, []);
  return ref;
}
